import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const LogoContainer = styled.nav`
  padding: 16px 0 16px 120px;

  @media (max-width: ${breakpoints.lg}) {
    padding-left: 24px;
  }
`;
